module.exports = __webpack_public_path__ + "img/PL00195.ca311c9e.png";